export default __webpack_public_path__ + "static/media/smarthealth.cd52e3b4.jpg";